export const FLOOR_PLANS = 'Floor Plans';
export const SITE_PLANS = 'Site Plans';
